import React, { useState, useRef, useEffect } from "react";

import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "../../../../redux/Reducer"; // Adjust the path as needed
import { GET_DETAILED_NEGOTIATION_OVERVIEW_SUCCESS } from "../../../../redux/Action/actionTypes"; // Adjust the path as needed

interface MeetingSummaryProps {
  summary: string;
  roundName: string;
  readOnly?: boolean;
  closeNegotiationPlaceholder?: string;
  negotiationStatus?: string;
}

const MeetingSummary = (props: MeetingSummaryProps) => {
  const { summary, roundName, readOnly = false, closeNegotiationPlaceholder = false, negotiationStatus = "" } = props;
  const [value, setValue] = useState<string>("");
  const quillRef = useRef<ReactQuill | null>(null);

  const dispatch = useDispatch();
  const negotiation = useSelector(
    (state: RootState) => state.dashboardData.detailedOverviewData
  );

  useEffect(() => {
    setValue(summary ?? "");
  }, [summary, roundName]);

  const handleCopy = async () => {
    const editor = quillRef.current?.getEditor();
    if (!editor) {
      console.log("Editor is not available.");
      return;
    }
    const html = editor.root.innerHTML;
    try {
      await navigator.clipboard.write([
        new ClipboardItem({
          "text/html": new Blob([html], { type: "text/html" }),
          "text/plain": new Blob([editor.getText()], { type: "text/plain" }),
        }),
      ]);
      console.log("Copied to clipboard with formatting!");
    } catch (err) {
      console.error("Failed to copy:", err);
    }
  };

  const handleChange = (content: string) => {
    if (negotiationStatus === "inProgress") {
      negotiation?.planNegotiationActions?.negotiationRoundsDetails.forEach(
        (round: any) => {
          if (round?.roundName === roundName) {
            round.meetingNotes = content;
          }
        }
      );

    } else {
      negotiation?.planNegotiationActions?.negotiationRoundsDetails.forEach(
        (round: any) => {
          if (round?.roundName === roundName) {
            round.meetingSummary = content;
          }
        }
      );
    }

    setValue(content);
    dispatch({
      type: GET_DETAILED_NEGOTIATION_OVERVIEW_SUCCESS,
      payload: negotiation,
    });
  };

  return (
    <div className="meeting-summary-container">
      {readOnly ? <div className="close-negotiation-ai-summary-header">Negotiation AI Summary:</div> : null}
      <button onClick={handleCopy} className="copy-button">
        Copy to Clipboard
      </button>
      <ReactQuill
        ref={quillRef}
        theme="snow"
        value={value}
        onChange={(value) => handleChange(value)}
        placeholder={closeNegotiationPlaceholder || "Enter meeting summary here..."}
        readOnly={readOnly}
      />
    </div>
  );
};

export default MeetingSummary;
